import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthenticatedUser } from '../models/authenticatedUser';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public tokenUrl = 'https://api.oncore.se/auth-token';
  public refreshTokenUrl = 'https://api.oncore.se/auth-token/refresh';
  private _apiBaseUrl = 'https://api.oncore.se/';
  public _isActiveUrl = 'https://api.oncore.se/user/isactive';
  public loginUrl = '/login';
  private _currentRoute = '/';
  private httpOptions: any;


  constructor(
    private _http: HttpClient,
    private _router: Router,
  ) {
    this.httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    };
  }

 
  refreshToken(): Observable<any> {
    const refreshToken = JSON.parse(localStorage.getItem('refresh_token'))
    return this._http.post(this._apiBaseUrl + 'auth-token/refresh', 'refresh=' + refreshToken, this.httpOptions).pipe(map(token => {
      this.saveToken('token', token['access']);
      return token
    }));
  }


  removeToken() {
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
  }

  saveToken(key, settings): string {
    localStorage.setItem(key, JSON.stringify(settings));
    return this.getLocalToken();
  }

  getLocalToken(): string {
    const token = JSON.parse(localStorage.getItem('token'));
    return token ? token : null;
  }

  fetchToken(userData): Observable<any> {
    return this._http.post(this.tokenUrl, userData).pipe(catchError(error => {
      return [error];
    }));

  }

  
  isActive(): Observable<boolean> {
    return this._http.get(this._apiBaseUrl + 'user/isactive').pipe(map(active => {
      return active as boolean
    }));
  }


  getUser(): Observable<AuthenticatedUser> {
    return this._http.get(this._apiBaseUrl + 'user/authenticatedUser').pipe(
      map(user => {
        return new AuthenticatedUser(user);
      }),
      catchError(err => {
        return [err];
      }));
  }

}
